<script setup lang="ts">
import { MetalPlanPageData } from '@/page/domain/MetalPlanPageData';

defineProps<{
  pageData: Partial<MetalPlanPageData>;
}>();

</script>
<template>
  <div class="w-full bg-blue py-16">
    <div class="flex flex-1 flex-col items-center justify-center max-w-7xl mx-auto relative space-y-6 px-6 lg:px-3">
      <h3 class="text-white font-bold" v-html="pageData.title"></h3>
      <div class="text-white text-center flex-col" v-html="pageData.content"></div>
    </div>
  </div>
</template>
